<template>
  <v-container class="py-0 px-5">
    <v-row>
      <v-col cols="12">
        <validated-text-field
          v-model="scheduledTransaction.name"
          field-name="name"
          rules="required"
          type="text"
        />
      </v-col>
      <v-col cols="12">
        <list-selector
          v-model="scheduledTransaction.memberships"
          :selected-source="scheduledTransaction.memberships"
          hint="memberships"
          autofocus
          no-translate
          field-name="membership_type"
          source-type="memberships"
          return-value="id"
        />
      </v-col>
      <v-col cols="12">
        <date-field
          v-model="scheduledTransaction.scheduled_date"
          field-name="scheduled_date"
          rules="required|date"
        />
      </v-col>
      <v-col cols="12">
        <validated-text-field
          v-model="scheduledTransaction.amount"
          field-name="amount"
          rules="required"
          type="number"
        />
      </v-col>
      <v-col cols="12">
        <data-selector
          v-model="scheduledTransaction.transaction_type_id"
          field-name="transaction_type"
          source-type="transactionTypes"
          filter="editable"
          translate
        />
      </v-col>
      <v-col cols="12">
        <v-checkbox
          v-model="scheduledTransaction.recurring"
          :label="$t('fields.recurring')"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'EditTransaction',
    props: {
      scheduledTransaction: Object,
    },
    data: function () {
      return {
        selected_memberships: [],
      }
    },
    computed: {
    },
    methods: {
    },
  }
</script>
